/* TOPSAFE — zoom de fotos de la ficha (estilo adidas).
   - Escritorio (mouse): lupa al pasar sobre cada foto de la grilla; clic abre el visor.
   - Visor a pantalla completa: miniaturas, flechas, teclado (← → Esc), clic para acercar y mover con el mouse.
   - Táctil: tocar una foto abre el visor; deslizar cambia de foto, doble toque o dos dedos para acercar, arrastrar para mover.
   Solo fotos (videos y modelos 3D siguen con su reproductor). Cargado en sections/main-product.liquid. */
(function () {
  var ZOOM = 2.5, MAX = 4;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var wide = window.matchMedia('(min-width: 993px)');

  function hiRes(img, w) {
    var src = img.currentSrc || img.src;
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', w);
      u.searchParams.delete('height');
      return u.toString();
    } catch (e) { return src; }
  }

  function track(event, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
  }

  function setup(list) {
    if (list.dataset.tscZoom) return;
    list.dataset.tscZoom = '1';

    /* fotos en el orden visible de la galería (el theme reordena al cambiar de variante) */
    function photos() {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item'))
        .map(function (li) { return li.querySelector('.product__modal-opener--image img'); })
        .filter(Boolean);
    }

    /* ---------- Lupa en la grilla (escritorio) ---------- */
    /* Una sola lupa activa; se apaga apenas el puntero sale de la foto (el botón transparente del theme
       sobre la foto impedía que llegara el pointerout y la lupa quedaba pegada). */
    var active = null;
    function clearLens() {
      document.querySelectorAll('.product__media.is-zooming').forEach(function (b) { b.classList.remove('is-zooming'); });
      active = null;
    }
    function inside(el, x, y) { var r = el.getBoundingClientRect(); return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; }
    document.addEventListener('pointermove', function (e) { if (active && !inside(active, e.clientX, e.clientY)) clearLens(); }, { passive: true });
    list.addEventListener('pointerleave', clearLens);
    window.addEventListener('blur', clearLens);
    list.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !fine.matches || !wide.matches) return;
      var li = e.target.closest('.product__media-item');
      var img = li && li.querySelector('.product__modal-opener--image img');
      if (!img) return;
      var box = img.closest('.product__media');
      var lens = box.querySelector('.tsc-lens');
      if (!lens) {
        lens = document.createElement('span');
        lens.className = 'tsc-lens';
        lens.setAttribute('aria-hidden', 'true');
        box.appendChild(lens);
        var url = hiRes(img, 2048), pre = new Image();
        pre.onload = function () { lens.style.backgroundImage = 'url("' + url + '")'; lens.classList.add('is-ready'); };
        pre.src = url;
      }
      var r = box.getBoundingClientRect();
      if (!inside(box, e.clientX, e.clientY)) { clearLens(); return; }
      if (active && active !== box) clearLens();
      active = box;
      var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
      var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
      lens.style.backgroundPosition = x + '% ' + y + '%';
      box.classList.add('is-zooming');
    });
    list.addEventListener('pointerout', function (e) {
      if (active && !inside(active, e.clientX, e.clientY)) clearLens();
    });

    /* ---------- Abrir visor (reemplaza el modal del theme para fotos) ---------- */
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.product__modal-opener--image .product__media-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var imgs = photos();
      var img = btn.closest('.product__modal-opener').querySelector('img');
      open(imgs, Math.max(0, imgs.indexOf(img)), btn);
    }, true);
  }

  /* ---------- Visor ---------- */
  var ui, state = { imgs: [], i: 0, s: 1, tx: 0, ty: 0, opener: null };

  function build() {
    ui = document.createElement('div');
    ui.className = 'tsc-zoom';
    ui.hidden = true;
    ui.setAttribute('role', 'dialog');
    ui.setAttribute('aria-modal', 'true');
    ui.setAttribute('aria-label', 'Fotos del producto');
    ui.innerHTML =
      '<div class="tsc-zoom__bar"><span class="tsc-zoom__count" aria-live="polite"></span>' +
      '<button type="button" class="tsc-zoom__close" aria-label="Cerrar"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="tsc-zoom__thumbs" role="tablist" aria-label="Miniaturas"></div>' +
      '<div class="tsc-zoom__stage"><div class="tsc-zoom__track"></div>' +
      '<button type="button" class="tsc-zoom__nav tsc-zoom__nav--prev" aria-label="Foto anterior"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="tsc-zoom__nav tsc-zoom__nav--next" aria-label="Foto siguiente"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<p class="tsc-zoom__hint"></p></div>';
    document.body.appendChild(ui);

    ui.querySelector('.tsc-zoom__close').addEventListener('click', close);
    ui.querySelector('.tsc-zoom__nav--prev').addEventListener('click', function () { go(state.i - 1); });
    ui.querySelector('.tsc-zoom__nav--next').addEventListener('click', function () { go(state.i + 1); });
    ui.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(state.i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(state.i + 1); }
      else if (e.key === 'Tab') { trapFocus(e); }
    });
    gestures(ui.querySelector('.tsc-zoom__stage'));
  }

  function trapFocus(e) {
    var f = Array.prototype.filter.call(ui.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(imgs, i, opener) {
    if (!ui) build();
    document.querySelectorAll('.product__media.is-zooming').forEach(function (b) { b.classList.remove('is-zooming'); });
    state.imgs = imgs; state.opener = opener;
    var trackEl = ui.querySelector('.tsc-zoom__track'), thumbs = ui.querySelector('.tsc-zoom__thumbs');
    trackEl.innerHTML = ''; thumbs.innerHTML = '';
    imgs.forEach(function (img, n) {
      var slide = document.createElement('div');
      slide.className = 'tsc-zoom__slide';
      var big = document.createElement('img');
      big.alt = img.alt || '';
      big.draggable = false;
      big.decoding = 'async';
      big.dataset.src = hiRes(img, 2048);
      big.src = img.currentSrc || img.src; /* se ve al tiro; la de alta resolución carga encima */
      slide.appendChild(big);
      trackEl.appendChild(slide);

      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'tsc-zoom__thumb';
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-label', 'Foto ' + (n + 1) + ' de ' + imgs.length);
      var ti = document.createElement('img');
      ti.alt = ''; ti.loading = 'lazy'; ti.src = hiRes(img, 160);
      t.appendChild(ti);
      t.addEventListener('click', function () { go(n); });
      thumbs.appendChild(t);
    });
    ui.classList.toggle('is-single', imgs.length < 2);
    ui.querySelector('.tsc-zoom__hint').textContent = fine.matches ? 'Haz clic en la foto para acercar' : 'Toca dos veces o usa dos dedos para acercar';
    ui.hidden = false;
    document.documentElement.classList.add('tsc-zoom-open');
    go(i, true);
    ui.querySelector('.tsc-zoom__close').focus({ preventScroll: true });
    track('tsc_pdp_zoom_open', { index: i + 1, total: imgs.length });
  }

  function close() {
    if (!ui || ui.hidden) return;
    ui.hidden = true;
    document.documentElement.classList.remove('tsc-zoom-open');
    if (state.opener) state.opener.focus({ preventScroll: true });
  }

  function slides() { return ui.querySelectorAll('.tsc-zoom__slide'); }
  function current() { return slides()[state.i]; }
  function curImg() { var s = current(); return s && s.querySelector('img'); }

  function go(n, instant) {
    var total = state.imgs.length;
    if (!total) return;
    n = (n + total) % total;
    reset();
    state.i = n;
    var trackEl = ui.querySelector('.tsc-zoom__track');
    trackEl.style.transition = instant ? 'none' : '';
    trackEl.style.transform = 'translateX(' + (-n * 100) + '%)';
    ui.querySelector('.tsc-zoom__count').textContent = (n + 1) + ' / ' + total;
    Array.prototype.forEach.call(ui.querySelectorAll('.tsc-zoom__thumb'), function (t, k) {
      t.setAttribute('aria-selected', k === n ? 'true' : 'false');
      if (k === n) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    /* alta resolución: la actual y las vecinas */
    [n, n + 1, n - 1].forEach(function (k) {
      var s = slides()[(k + total) % total], im = s && s.querySelector('img');
      if (im && im.dataset.src) { var pre = new Image(), url = im.dataset.src; delete im.dataset.src; pre.onload = function () { im.src = url; }; pre.src = url; }
    });
  }

  /* ---------- Zoom / paneo ---------- */
  function stageBox() { return ui.querySelector('.tsc-zoom__stage').getBoundingClientRect(); }
  function clamp() {
    var r = stageBox(), mx = r.width * (state.s - 1) / 2, my = r.height * (state.s - 1) / 2;
    state.tx = Math.max(-mx, Math.min(mx, state.tx));
    state.ty = Math.max(-my, Math.min(my, state.ty));
  }
  function apply(animate) {
    var im = curImg();
    if (!im) return;
    clamp();
    im.style.transition = animate ? 'transform .25s ease' : 'none';
    im.style.transform = 'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.s + ')';
    ui.classList.toggle('is-zoomed', state.s > 1.01);
  }
  function reset() {
    var im = curImg();
    state.s = 1; state.tx = 0; state.ty = 0;
    if (im) { im.style.transition = 'none'; im.style.transform = ''; }
    if (ui) ui.classList.remove('is-zoomed');
  }
  /* área real de la foto dentro del escenario (object-fit: contain) */
  function photoRect() {
    var r = stageBox(), im = curImg();
    var nw = im && im.naturalWidth, nh = im && im.naturalHeight;
    if (!nw || !nh) return r;
    var k = Math.min(r.width / nw, r.height / nh), w = nw * k, h = nh * k;
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, right: r.left + (r.width + w) / 2, bottom: r.top + (r.height + h) / 2 };
  }
  function overPhoto(x, y) { var p = photoRect(); return x >= p.left && x <= p.right && y >= p.top && y <= p.bottom; }
  /* ubica el punto (x, y) de la pantalla bajo el cursor con la escala dada (mouse: seguir el puntero) */
  function aim(x, y, s) {
    var r = stageBox();
    state.s = s;
    state.tx = (r.width / 2 - (x - r.left)) * (s - 1);
    state.ty = (r.height / 2 - (y - r.top)) * (s - 1);
  }

  function gestures(stage) {
    var pts = {}, start = null, lastTap = 0, moved = false;

    function count() { return Object.keys(pts).length; }
    function pair() { var k = Object.keys(pts); return [pts[k[0]], pts[k[1]]]; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      moved = false;
      if (count() === 2) {
        var p = pair();
        start = { d: dist(p[0], p[1]), s: state.s, tx: state.tx, ty: state.ty, cx: (p[0].x + p[1].x) / 2, cy: (p[0].y + p[1].y) / 2, pinch: true };
      } else {
        start = { x: e.clientX, y: e.clientY, tx: state.tx, ty: state.ty, pinch: false };
      }
    });

    stage.addEventListener('pointermove', function (e) {
      /* mouse con zoom activo: la foto sigue al cursor (como adidas) */
      if (e.pointerType === 'mouse') {
        if (state.s > 1 && !count()) {
          if (!overPhoto(e.clientX, e.clientY)) { reset(); apply(true); return; }
          aim(e.clientX, e.clientY, state.s); apply(false);
        }
        return;
      }
      if (!pts[e.pointerId] || !start) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (start.pinch && count() === 2) {
        var p = pair(), r = stageBox();
        var s = Math.max(1, Math.min(MAX, start.s * dist(p[0], p[1]) / start.d));
        var cx = start.cx - r.left - r.width / 2, cy = start.cy - r.top - r.height / 2;
        state.tx = cx - (cx - start.tx) * s / start.s;
        state.ty = cy - (cy - start.ty) * s / start.s;
        state.s = s;
        moved = true;
        apply(false);
      } else if (!start.pinch) {
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
        if (state.s > 1) {
          state.tx = start.tx + dx; state.ty = start.ty + dy; apply(false);
        } else {
          var trackEl = ui.querySelector('.tsc-zoom__track');
          trackEl.style.transition = 'none';
          trackEl.style.transform = 'translateX(calc(' + (-state.i * 100) + '% + ' + dx + 'px))';
        }
      }
    });

    function end(e) {
      if (!pts[e.pointerId]) return;
      var wasPinch = start && start.pinch;
      delete pts[e.pointerId];
      if (e.pointerType === 'mouse') {
        if (!moved) {
          if (state.s > 1) { reset(); apply(true); }
          else if (overPhoto(e.clientX, e.clientY)) { aim(e.clientX, e.clientY, ZOOM); apply(true); }
        }
        start = null;
        return;
      }
      if (wasPinch) {
        if (count() === 1) { var k = Object.keys(pts)[0]; start = { x: pts[k].x, y: pts[k].y, tx: state.tx, ty: state.ty, pinch: false }; }
        else start = null;
        if (state.s < 1.05) { reset(); apply(true); }
        return;
      }
      if (!start) return;
      var dx = e.clientX - start.x;
      if (state.s <= 1 && moved) {
        var w = stageBox().width;
        if (dx < -w * 0.15) go(state.i + 1);
        else if (dx > w * 0.15) go(state.i - 1);
        else go(state.i);
      } else if (!moved) {
        var now = Date.now();
        if (now - lastTap < 300) {
          if (state.s > 1) reset(); else aim(e.clientX, e.clientY, ZOOM);
          apply(true);
          lastTap = 0;
        } else lastTap = now;
      }
      start = null;
    }
    stage.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && state.s > 1 && !count()) { reset(); apply(true); } });
    window.addEventListener('blur', function () { if (ui && !ui.hidden && state.s > 1) { reset(); apply(true); } });
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    /* rueda del mouse: acercar / alejar */
    stage.addEventListener('wheel', function (e) {
      if (!fine.matches) return;
      e.preventDefault();
      var s = Math.max(1, Math.min(MAX, state.s * (e.deltaY < 0 ? 1.15 : 1 / 1.15)));
      if (s < 1.05) { reset(); apply(true); return; }
      aim(e.clientX, e.clientY, s); apply(false);
    }, { passive: false });
  }

  function init() {
    document.querySelectorAll('[id^="Slider-Gallery-"]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
